import { Container, Group, Title, Text, SimpleGrid, Card, Badge, Skeleton } from '@mantine/core';
import { useSocialPosts, useSocialCampaigns } from '@/hooks/usePortalApi';

const PLATFORM_COLORS: Record<string, string> = {
  facebook: 'blue',
  instagram: 'pink',
  twitter: 'cyan',
  linkedin: 'indigo',
};

export default function SocialContent() {
  const { data: posts, isLoading: postsLoading } = useSocialPosts();
  const { data: campaigns } = useSocialCampaigns();

  const getCampaignName = (campaignId: number | null) => {
    if (!campaignId || !campaigns) return null;
    const campaign = campaigns.find((c: any) => c.id === campaignId);
    return campaign?.name;
  };

  return (
    <Container size="lg" py="md">
      <Group justify="space-between" mb="md">
        <div>
          <Title order={2}>News & Promotions</Title>
          <Text c="dimmed" size="sm">Latest updates from Standard Produce</Text>
        </div>
      </Group>

      {postsLoading ? (
        <SimpleGrid cols={2}>
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} shadow="sm" padding="lg" withBorder>
              <Skeleton height={20} width="30%" mb="md" />
              <Skeleton height={100} mb="md" />
              <Skeleton height={15} width="60%" />
            </Card>
          ))}
        </SimpleGrid>
      ) : !posts || posts.length === 0 ? (
        <Text ta="center" c="dimmed" py="xl">No posts available</Text>
      ) : (
        <SimpleGrid cols={2}>
          {posts.map((post: any) => (
            <Card key={post.id} shadow="sm" padding="lg" withBorder>
              <Group mb="xs">
                <Badge color={PLATFORM_COLORS[post.platform] || 'gray'} variant="light">
                  {post.platform}
                </Badge>
                {post.campaign_id && (
                  <Badge color="grape" variant="light">
                    {getCampaignName(post.campaign_id)}
                  </Badge>
                )}
              </Group>

              <Text size="sm" mb="md" lineClamp={4}>
                {post.content}
              </Text>

              {post.media_url && (
                <Card.Section mb="sm">
                  <div style={{ height: 150, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Text c="dimmed" size="sm">Image placeholder</Text>
                  </div>
                </Card.Section>
              )}

              <Text size="xs" c="dimmed">
                {new Date(post.published_at).toLocaleDateString()}
              </Text>
            </Card>
          ))}
        </SimpleGrid>
      )}
    </Container>
  );
}
